<ng-container *ngIf="sliderArray && sliderArray.length > 0">
  <owl-carousel-o [options]="options" >
    <ng-container *ngFor="let slide of sliderArray;let i=index">
      <ng-template carouselSlide [id]="index">
        <div  style="width:100%;height:400px" class="d-flex">
          <img class="img-responsive w-100 h-100"  [src]="slide.image"
          (click)="onClickImage(slide.href)"
          style="cursor: pointer">
      </div>
      </ng-template>
      </ng-container>
  </owl-carousel-o>
</ng-container>
